import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import { Button, FormControlLabel, MenuItem, Select } from "@mui/material";
import { Box, Typography } from "@mui/material";

import { Formik } from "formik";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";

const PopupForm = (props) => {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const { open, close, task, updateTaskParams } = props;

  const {
    url,
    focused,
    evasive,
    filterByDomain,
    depth,
    evasive_mode,
    threshold,
    monitoring,
    monitoring_interval,
    site_id,
  } = task;

  console.log("MONIT ", monitoring_interval);

  return (
    <Formik
      initialValues={{
        url: url,
        depth: depth,
        focused: focused,
        evasive: evasive,
        filterByDomain: filterByDomain,
        evasive_mode: evasive_mode,
        threshold: threshold,
        monitoring_interval: monitoring_interval,
        monitoring: monitoring,
      }}
      onSubmit={(values) => {
        updateTaskParams({ site_id, ...values });
      }}
    >
      {({ handleChange, handleBlur, handleSubmit, resetForm, values }) => (
        <Dialog open={open}>
          <DialogTitle>
            <Typography> {url} </Typography>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                // One row per setting: each switch and its control are grid
                // siblings, so they stay aligned however many rows there are.
                // The previous two space-evenly columns only looked aligned
                // while both happened to hold the same number of items.
                display: "grid",
                gridTemplateColumns: "1fr auto",
                columnGap: 3,
                alignContent: "space-evenly",
                alignItems: "center",
                minWidth: 500,
                minHeight: 500,
              }}
            >
              <FormControlLabel
                label={<Typography>Filter by domain</Typography>}
                control={
                  <Switch
                    onChange={handleChange("filterByDomain")}
                    value={values.filterByDomain}
                    checked={values.filterByDomain}
                  />
                }
              />
              <TextField
                sx={{ maxWidth: 100, minWidth: 100 }}
                onChange={handleChange("depth")}
                value={values.depth}
                variant={"outlined"}
                type="number"
                label="Depth"
                size="small"
                InputProps={{ inputProps: { min: 0 } }}
              />

              <FormControlLabel
                control={
                  <Switch
                    onChange={handleChange("monitoring")}
                    value={values.monitoring}
                    checked={values.monitoring}
                  />
                }
                label={"Monitoring"}
              />
              <TextField
                sx={{ maxWidth: 100, minWidth: 100 }}
                onChange={handleChange("monitoring_interval")}
                value={values.monitoring_interval}
                variant="outlined"
                type="number"
                label="Interval (days)"
                size="small"
                InputProps={{ inputProps: { min: 0 } }}
              />

              <FormControlLabel
                control={
                  <Switch
                    {...label}
                    onChange={handleChange("focused")}
                    value={values.focused}
                    checked={values.focused}
                  />
                }
                label={"Focused"}
              />
              {/* Threshold sat here. Hidden until the web crawler actually applies
                  it: its focused pipeline (KafkaClassifierSubmitPipeline) is
                  fire-and-forget and never compares a confidence, and the Kafka
                  message carries no threshold for cti-llm to apply either, so
                  cti-llm keeps whatever it labels "True". The social crawlers DO
                  honour their threshold (social-crawlers/tasks.py), so this is
                  hidden here only. The value is still submitted from
                  initialValues, so the API contract is unchanged. */}
              <Box />

              <FormControlLabel
                control={
                  <Switch
                    onChange={handleChange("evasive")}
                    value={values.evasive}
                    checked={values.evasive}
                  />
                }
                label="Evasive"
              />
              <Select
                sx={{ minWidth: 100 }}
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={values.evasive_mode}
                label="Evasive mode"
                onChange={handleChange("evasive_mode")}
                variant="outlined"
                size="small"
              >
                <MenuItem value={"heuristics"}>Heuristics</MenuItem>
                {/* <MenuItem value={"gans"}>GANS</MenuItem>
                <MenuItem value={"prerecorded"}>Prerecorded</MenuItem> */}
              </Select>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant={"contained"}
              onClick={() => {
                handleSubmit();
                close();
              }}
            >
              OK
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                resetForm();
                close();
              }}
            >
              Cancel
            </Button>
            {/* <Button onClick={handleClose}>Subscribe</Button> */}
          </DialogActions>
        </Dialog>
      )}
    </Formik>
  );
};

export default PopupForm;
